import { useState, useId } from 'react'
import { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { Collapsible, Text, Link } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { ExpandingTextData, ExpandingTextSettings } from './types'
import { AnyBlock, BlockRenderer, type BlockSettings } from '../BlockRenderer'

export const ExpandingText: ShopifySectionComponent<ExpandingTextData> = ({
  data,
}) => {
  const { blocks = [] } = data || {}
  const [isExpanded, setIsExpanded] = useState(false)
  const { t } = useTranslation()
  const collapsibleId = useId()

  const globalBlocks = blocks.filter(
    (block) => 'type' in block && block.type !== 'expanding_text',
  ) as AnyBlock<Pick<BlockSettings, 'text' | 'heading'>>[]

  const expandingTextBlock = blocks.find(
    (block) => 'type' in block && block.type === 'expanding_text',
  ) as ExpandingTextSettings | undefined

  return (
    <div className="flex flex-col gap-y-4">
      <BlockRenderer<BlockSettings> blocks={globalBlocks} />
      {expandingTextBlock ? (
        <div>
          <Collapsible
            id={collapsibleId}
            open={isExpanded}
            transition={{ duration: '0.25s' }}
            keepMounted={true}
          >
            {expandingTextBlock.blocks.map((block) => (
              <Text
                key={block.id}
                variant={block.settings.text_size}
                className={block.settings.text_colour}
                dangerouslySetInnerHTML={{
                  __html: block.settings.text,
                }}
              />
            ))}
          </Collapsible>
          <Link
            as="button"
            onClick={() => setIsExpanded(!isExpanded)}
            className={classNames('link', isExpanded && 'mt-3')}
            aria-expanded={isExpanded}
            aria-controls={collapsibleId}
          >
            {isExpanded
              ? t('action.read_less' as any)
              : t('action.read_more' as any)}
          </Link>
        </div>
      ) : undefined}
    </div>
  )
}
